import { render, staticRenderFns } from "./MainPart.vue?vue&type=template&id=1a86c65c&"
import script from "./MainPart.vue?vue&type=script&lang=js&"
export * from "./MainPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports